// Session expiration timeout for users logged without remember me option
export const SESSION_EXPIRATION = 1000 * 60 * 60 * 24;

export const DISCOUNT_VALUE_PERCENT = 0;
export const DISCOUNT_VALUE_AMOUNT = 1;

export const PRICE_TYPE_STANDARD = "standard";
export const PRICE_TYPE_INDIVIDUAL = "individual";
export const PRICE_TYPE_DISCOUNTED = 'discounted';